// Generated by ReScript, PLEASE EDIT WITH CARE


let DayPickerSingleDateController = {};

let DayPickerRangeController = {
  defaultFocusedInput: "startDate"
};

export {
  DayPickerSingleDateController,
  DayPickerRangeController,
}
/* No side effect */
